import { graphql, Link, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import get from "lodash/get"

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap"

import "./header.less"

export default () => {
  const [mobileMenu, showMobileMenu] = useState(false)

  const {
    cms: { solutions, solutionPage, globalSets },
  } = useStaticQuery(graphql`
    query {
      cms {
        globalSets(handle: "mainMenuLabels") {
          ... on Cms_mainMenuLabels_GlobalSet {
            id
            name
            section1Text
          }
        }
        solutions: entries(section: "solutions", limit: 50) {
          id
          ... on Cms_solutions_solutions_Entry {
            id
            title
            slug
            hasADedicatedPage
            displayInSolutionsPage
            introSectionText
            thumbnails: solutionImages {
              url(width: 650, height: 365)
              title
            }
            thumbnailsRetina: solutionImages {
              url(width: 1300, height: 730)
              title
            }
            images: solutionImages {
              url(width: 1920)
              title
            }
            solutionLink {
              ... on Cms_solutionLink_solutionLink_BlockType {
                id
                solutionLinkLabel
                solutionLink
              }
            }
          }
        }
        solutionPage: entry(section: "solutionsPage", limit: 100) {
          id
          ... on Cms_solutionsPage_solutionsPage_Entry {
            id
            imageSectionTitle
          }
        }
      }
    }
  `)

  const menuLinksArray = globalSets?.[0]?.section1Text?.split("\n") || []

  const solutionMenuLinks = solutions.filter(
    (item) => item.displayInSolutionsPage
  )

  const faqLink = solutions.find((item) => item.slug.indexOf("faq") > -1)

  return (
    <header>
      <div className={"container"}>
        <nav className="navbar navbar-light bg-transparent position-relative">
          <Link className="navbar-brand" to="/">
            <img
              src={require("../images/logo.svg").default}
              alt={"Workplace One Logo"}
              className={"my-0"}
            />
          </Link>

          <button
            className="btn btn-link d-block d-xl-none mobile-menu-trigger"
            onClick={() => showMobileMenu(true)}
          >
            <span />
            <span />
            <span />
          </button>

          <ul className="navbar-nav d-none d-xl-block">
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClassName={"active"}
                to="/why-workplace-one"
              >
                {menuLinksArray?.[0] || "Why Workplace One"}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClassName={"active"}
                to="/locations"
              >
                {menuLinksArray?.[1] || "Locations"}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link has-mega-menu"
                activeClassName={"active"}
                to="/solutions"
              >
                {menuLinksArray?.[2] || "Membership Solutions"}
              </Link>
              <div className={"header-mega-menu"}>
                <div>
                  <div className="row">
                    <div className="col-sm-8 py-5">
                      <div className="row">
                        {solutionMenuLinks.map((link, idx) => {
                          const margin = idx > 1 ? "mt-4" : ""
                          const customLink =
                            get(
                              link,
                              "solutionLink[0].solutionLink",
                              "/solutions"
                            ) || "/solutions"

                          let to = link.hasADedicatedPage
                            ? `/solutions/${link.slug}`
                            : customLink

                          if (link.slug === "coworking-memberships") {
                            to = `/solutions/#${link.slug}`
                          }
                          return (
                            <div className={`col-6 ${margin}`} key={link.id}>
                              <Link to={to}>
                                <h5>{link.title}</h5>
                                <p>{link.introSectionText}</p>
                              </Link>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="col-sm-4 py-5 bg-light-grey">
                      <Link to={"/solutions"}>
                        <h5 className="color-green">Overview</h5>
                        <p>{solutionPage.imageSectionTitle}</p>
                      </Link>

                      {faqLink && faqLink.title ? (
                        <>
                          <Link to={`/solutions/${faqLink.slug}`}>
                            <h5 className="color-green mt-4">
                              {faqLink.title}
                            </h5>
                            <p>{faqLink.introSectionText}</p>
                          </Link>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClassName={"active"}
                to="/reserve-workspace"
              >
                {menuLinksArray?.[3] || "On-Demand Bookings"}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/locations"}>
                {menuLinksArray?.[4] || "Find Workspace"}
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <MobileMenu
        show={mobileMenu}
        showMobileMenu={showMobileMenu}
        solutions={solutions}
      />
    </header>
  )
}

const MobileMenu = ({ show, showMobileMenu, solutions }) => {
  const [solutionsOpen, setSolutionsOpen] = useState("0")

  const closeMenu = () => showMobileMenu(false)
  if (!show) {
    return null
  }
  return (
    <div className={"mobile-menu-wrapper"}>
      <div className="container">
        <Link to="/" onClick={() => showMobileMenu(false)}>
          <img
            src={require("../images/white-logo.svg").default}
            alt={"Workplace One Logo"}
            className={"mobile-menu-logo"}
          />
        </Link>

        <button className="btn btn-link" onClick={() => showMobileMenu(false)}>
          <img
            src={require("../images/icons/menu-close.svg").default}
            alt={"Close menu"}
            className={"my-0"}
          />
        </button>

        <ul className="mobile-menu">
          <li>
            <Link
              activeClassName={"active"}
              to="/why-workplace-one"
              onClick={closeMenu}
            >
              Why Workplace One
            </Link>
          </li>
          <li>
            <Link
              activeClassName={"active"}
              to="/locations"
              onClick={closeMenu}
            >
              Locations
            </Link>
          </li>
          <li>
            <Accordion
              className="header-accordion-menu"
              open={solutionsOpen}
              toggle={(id) => {
                id === solutionsOpen
                  ? setSolutionsOpen("0")
                  : setSolutionsOpen(id)
              }}
            >
              <AccordionItem>
                <AccordionHeader
                  targetId="1"
                  className="header-accordion-menu button"
                >
                  <a className={"link"}>Membership Solutions</a>
                </AccordionHeader>
                <AccordionBody
                  accordionId="1"
                  className="header-accordion-menu body"
                >
                  <ul>
                    <li>
                      <Link to="/solutions">Overview</Link>
                    </li>
                    {solutions.map((item) => {
                      const customLink =
                        get(
                          item,
                          "solutionLink[0].solutionLink",
                          "/solutions"
                        ) || "/solutions"

                      let link = item.hasADedicatedPage
                        ? `/solutions/${item.slug}`
                        : customLink

                      if (item.slug === "coworking-memberships") {
                        link = `/solutions/#${item.slug}`
                      }

                      return (
                        <li key={item.id}>
                          <Link to={link} onClick={closeMenu}>
                            {item.title}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </li>
          <li>
            <Link
              activeClassName={"active"}
              to="/reserve-workspace"
              onClick={closeMenu}
            >
              On-Demand Bookings
            </Link>
          </li>
          <li>
            <Link
              to={"/locations?location=Toronto&onboard=true"}
              // onClick={closeMenu}
            >
              Find Workspace
            </Link>
          </li>

          <li className="separator" />

          <li>
            <Link className="sub-nav" to={`/contact`} onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
          <li>
            <Link className="sub-nav" to={`/blog`} onClick={closeMenu}>
              Blog
            </Link>
          </li>
          <li>
            <Link className="sub-nav" to={`/meeting-rooms`} onClick={closeMenu}>
              Meeting Rooms
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}
